import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import {
  BaseCrud,
  FormSection,
  FormSectionColumn
} from 'react/containers/layout/Crud';
import { TextField, LookupField } from 'react/components/fields';
import { actionCreators } from 'react/api/actions/crud';

function TaskReasonCrud(props) {
  const { saveFormAction } = props;
  const dispatch = useDispatch();

  const handleSubmitAction = (payload) => {
    if (!payload.id) {
      Object.assign(payload, {
        updateMethod: 'POST',
        entity: `${payload.entity}/Save`
      });
    }
    saveFormAction(payload);
  };

  return (
    <BaseCrud
      {...props}
      updateMethod="PATCH"
      tabName="TaskReason.title"
      customSubmitAction={handleSubmitAction}
      afterSubmit={() => {
        dispatch(push('/TaskReason'));
      }}
    >
      <FormSection title="TaskReason.section.general.title">
        <FormSectionColumn>
          <LookupField
            label="TaskReason.field.organization"
            name="organization"
            lookupEntity="Organization"
            lookupEntityColumn="description"
            required
          />
          <TextField
            label="TaskReason.field.description"
            name="description"
            required
          />
        </FormSectionColumn>
      </FormSection>
    </BaseCrud>
  );
}

TaskReasonCrud.propTypes = {
  saveFormAction: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  saveFormAction: actionCreators.saveForm
};

export default connect(null, mapDispatchToProps)(TaskReasonCrud);
